export enum ListingActivityType {
    PickListed,
    Liked,
    Disliked,
    Shown,
    Viewed,
    Shared,
    CommentAdded
}
